import { errorMiddleware } from "./error-toast-middleware";

export const getMiddlewares = () => {
  return [
    errorMiddleware,
  ]
}
